import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import * as moment from 'moment';

import { CommonService } from '../../services/common.service';
import { ShareService } from '../../services/share.service';

@Component({
  selector: 'app-turno',
  templateUrl: './turno.component.html',
  styleUrls: ['./turno.component.scss'],
  providers: [CommonService]
})
export class TurnoComponent implements OnInit {
  private search = {};

  public selectedEspecialidad = 0;
  public selectedCiudad = 0;
  public selectedBarrio = 0;
  public selectedDate:Date;
  public selectedFranja;

  public especialidades:any[];
  public ciudades:any[];
  public barrios:any[];
  public obras_sociales:any[];
  public franjas:any[];

  public pacientes = {
    adultos: [],
    menores: []
  };
  public counters = {
    adultos:0,
    menores:0
  };

  private now = moment();
  public nextDate:Date;
  public es:any;

  constructor(private commonService:CommonService, 
    private shareService:ShareService,
    private router:Router) { }

  ngOnInit() {
    Promise.all([
      this.commonService.getEspecialiades(),
      this.commonService.getCiudades(),
      this.commonService.getOS()
    ]).then(result => {
      this.especialidades = result[0];
      this.ciudades = result[1];
      this.obras_sociales = result[2];
    });

    this.es = {
      firstDayOfWeek: 0,
      dayNames: [ "domingo","lunes","martes","miércoles","jueves","viernes","sábado" ],
      dayNamesShort: [ "dom","lun","mar","mié","jue","vie","sáb" ],
      dayNamesMin: [ "D","L","M","X","J","V","S" ],
      monthNames: [ "enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre" ],
      monthNamesShort: [ "ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic" ]
    };

    this.nextDate = this.now.add(2,'day').toDate();

    this.franjas = [
      {
        id:1,
        label:"Por la mañana (08-14hs)"
      },
      {
        id:2,
        label:"Por la tarde (14-20hs)"
      },
      {
        id:3,
        label:"Cualquier horario disponible"
      }
    ];

    this.selectedFranja = 3;
  }

  public getBarrios():void {
    this.selectedBarrio = 0;
    this.commonService.getBarriosXCiudad(this.selectedCiudad)
      .then(result => this.barrios = result);
  }

  public changeCounter(isAdding, collection):void {
    if (isAdding) {
      this.counters[collection]++;
      if (this.pacientes.adultos[0]) {
        this.pacientes[collection].push(
          {
            "nro":this.counters[collection], 
            "os":this.pacientes.adultos[0].os,
            "nombre":'',
            "apellido":'',
            "dni":'',
            "email":'',
            "telefono":'',
            "nombre_ar":'',
            "apellido_ar":''
          }
        );
      } else {
        this.pacientes[collection].push(
          {
            "nro":this.counters[collection], 
            "os":0,
            "nombre":'',
            "apellido":'',
            "dni":'',
            "email":'',
            "telefono":'',
            "nombre_ar":'',
            "apellido_ar":''
          }
        );
      }
    } else {
      if (this.pacientes[collection].length === 0) {
        return;
      }
      this.counters[collection]--;
      this.pacientes[collection].pop();
    }
  }

  public checkOS(nro) {
    if (nro === 1) {
      let commonOS = this.pacientes.adultos[0].os;
      this.pacientes.adultos.forEach(function(a) {
        a.os = commonOS;
      });
      this.pacientes.menores.forEach(function(m) {
        m.os = commonOS;
      });
    }
  }

  public searchTurnos() { 
    let os = this.getOSsearch();
    let franja = this.getFranja();
    let dia = this.getDia();

    this.search = {
      os: os,
      especialidad: this.selectedEspecialidad,
      dia: dia,
      franja: franja,
      barrio: this.selectedBarrio,
      fecha: this.selectedDate,
      pacientes: this.pacientes
    };

    this.shareService.setSearch(this.search);
    this.router.navigate(['/turnos']);
  }

  public validateSearch():boolean {
    let valid = false;
    let validPacientes = false; 

    if(this.pacientes.adultos.length > 0) {
      validPacientes = this.pacientes.adultos[0].os > 0;
    } else if (this.pacientes.adultos.length === 0 && this.pacientes.menores.length > 0) {
      validPacientes = this.pacientes.menores[0].os > 0;
    } else if (this.pacientes.adultos.length > 0 && this.pacientes.menores.length > 0) {
      validPacientes = this.pacientes.adultos[0].os > 0 && this.pacientes.menores[0].os > 0;
    }

    if (this.selectedEspecialidad && 
      this.selectedCiudad && 
      this.selectedBarrio &&
      this.selectedFranja &&
      validPacientes) {
      valid = true;
    }

    return valid;
  }

  private getOSsearch() {
    let os = [];
    this.pacientes.adultos.forEach(a => {
      if (os.indexOf(a.os) == -1) {
          os.push(a.os);
      }
    });
    this.pacientes.menores.forEach(m => {
      if (os.indexOf(m.os) == -1) {
          os.push(m.os);
      }
    });

    return os;
  }

  private getFranja() {
    let franja = [];

    if (this.selectedFranja === 1) {
      franja.push('Mañana');
    } else if (this.selectedFranja === 2) {
      franja.push('Tarde');
    } else if (this.selectedFranja === 3) {
      franja = ['Mañana', 'Tarde'];
    }

    return franja;
  }

  private getDia() {
    let dia;

    if(!this.selectedDate) {
      this.selectedDate = moment().add(2, 'd').toDate();
    }

    dia = moment(this.selectedDate).weekday();

    if (dia === 6) {
      this.selectedDate = moment(this.selectedDate).add(2,'d').toDate();
      dia = 1;
    }

    if (dia === 0) {
      this.selectedDate = moment(this.selectedDate).add(1,'d').toDate();
      dia = 1;
    }

    return dia;
  }
}



// WEBPACK FOOTER //
// /Users/tretapey/Documents/Programmer/craCSS/DOC-in/src/app/home/turno/turno.component.ts